// extracted by mini-css-extract-plugin
module.exports = {"purple":"#7349cc","wrapper":"Text-module--wrapper--3PDLb","input":"Text-module--input--3k1eK","hasIcon":"Text-module--hasIcon--18Vfz","label":"Text-module--label--2bg5s"};